import React from 'react';
import {useStyles} from './TakisBoxWithImage.styles';
import TakisPicture from './TakisPicture';
import PropTypes from 'prop-types';

function TakisBoxWithImage({imageSrc, imageMobileSrc, imageAlt, caption}) {
    const classes = useStyles();
    const images = [
      {
        url: imageMobileSrc,
        size: "mobile"
      },
      {
        url: imageSrc,
        size: "desktop"
      }
    ];

    TakisBoxWithImage.propTypes = {
      imageSrc: PropTypes.string.isRequired,
      imageAlt: PropTypes.string.isRequired,
      caption: PropTypes.string
    };

    return (
      <div className={`${classes.imageContainer} ${caption ? classes.extraMargin : ""}`}>
        <TakisPicture
          pictureClass={classes.image}
          images={images}
          isLazy={false}
          altText={imageAlt}
        />
        {
          caption &&
          <div className={classes.captionContainer}>
            <span className={classes.caption}>
              {caption}
            </span>
          </div>
        }
      </div>
  );
}

export default TakisBoxWithImage;
